import React from 'react'
const SvgProvide1 = props => (
  <svg id='provide1_svg___\u56FE\u5C42_2' viewBox='0 0 43 48.39' {...props}>
    <defs>
      <style>{'.provide1_svg__cls-1{fill:#fd5c1f}'}</style>
    </defs>
    <g id='provide1_svg___\u56FE\u5C42_1-2'>
      <path
        className='provide1_svg__cls-1'
        d='M16.88 24.2c0-.55-.22-1.06-.61-1.44l-5.22-5.09c-.4-.39-1.04-.39-1.44 0-.2.19-.3.45-.3.72 0 .27.11.53.3.72l5.22 5.09-5.22 5.09c-.2.19-.3.45-.3.72 0 .27.11.53.3.72.19.19.45.29.72.29s.53-.1.72-.29l5.21-5.09c.39-.38.61-.9.61-1.44zM22.96 29.28c-.81-.79-2.12-.78-2.92 0l-5.22 5.09c-.2.19-.31.45-.3.72 0 .27.11.53.3.72.4.39 1.05.39 1.44 0l5.25-5.09 5.21 5.09c.19.19.45.29.72.29s.53-.1.72-.29c.2-.19.3-.45.3-.72 0-.27-.11-.53-.3-.72l-5.22-5.09zM28.17 24.2l5.22-5.09c.2-.19.3-.45.3-.72 0-.27-.11-.53-.3-.72-.4-.39-1.05-.39-1.44 0l-5.22 5.09c-.39.38-.61.9-.61 1.44s.22 1.06.61 1.44l5.22 5.09c.19.19.45.29.72.29s.53-.1.72-.29c.2-.19.3-.45.3-.72 0-.27-.11-.53-.3-.72l-5.22-5.09zM20.04 19.11c.39.38.91.59 1.46.59s1.07-.21 1.46-.59l5.22-5.09c.2-.19.3-.45.3-.72a1.032 1.032 0 00-1.75-.72l-5.25 5.09-5.22-5.09c-.4-.39-1.04-.39-1.44 0-.2.19-.31.45-.3.72 0 .27.11.53.3.72l5.22 5.09z'
      />
      <path
        d='M42 14.67c0-1.52-1.08-3.37-2.39-4.13l-15.7-8.97c-1.32-.75-3.5-.75-4.82 0L3.42 10.53C2.06 11.31 1 13.14 1 14.71v18.98c0 1.52 1.08 3.38 2.4 4.14l15.69 8.98c.66.38 1.51.58 2.41.58s1.75-.21 2.41-.58l15.69-8.98c1.32-.76 2.4-2.62 2.4-4.14V14.67z'
        fill='none'
        stroke='#2b4b67'
        strokeMiterlimit={10}
        strokeWidth={2}
      />
    </g>
  </svg>
)
export default SvgProvide1
